import styled from 'styled-components';

export const NotificationWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing[4]} 0;
`;
